import './SecHeader.css'

interface SecHeaderProps {
  title: string;
  lightMode?: boolean;
  sectionId?: string;
}

const SecHeader: React.FC<SecHeaderProps> = ({ title , lightMode= true, sectionId = "" }) => {
  return (
    <div id={sectionId} className={lightMode ? "section-header" : "section-header-dark"}>
      <h2>{title}</h2>
    </div>
  );
};

export default SecHeader;